var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c("h2", [_vm._v("REGISTRO DE TARIFAS POR CAMPAÑA")]),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-btn",
                {
                  staticClass: "add__new-button mr-3",
                  on: {
                    click: function($event) {
                      _vm.addNewItem()
                    }
                  }
                },
                [_vm._v("NUEVA TARIFA")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { outline: "", color: "primary" },
                  on: {
                    click: function($event) {
                      _vm.reportDownload()
                    }
                  }
                },
                [_vm._v("EXPORTAR DATOS")]
              ),
              _c("v-spacer"),
              _c("v-spacer"),
              _c("v-text-field", {
                attrs: {
                  "append-icon": "search",
                  label: "BUSCAR POR PLATAFORMA, CANAL, SUBPRODUCTO O MONEDA",
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c(
            "v-data-table",
            {
              attrs: {
                headers: _vm.headers,
                items: _vm.tariffs,
                search: _vm.search,
                "hide-actions": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "headers",
                  fn: function(props) {
                    return [
                      _c("tr", [
                        _c("th", { staticClass: "slide__item-row" }, [
                          _vm._v(_vm._s(props.headers[0].text))
                        ]),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [_c("div", [_vm._v(_vm._s(props.headers[1].text))])]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [_c("div", [_vm._v(_vm._s(props.headers[2].text))])]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [_c("div", [_vm._v(_vm._s(props.headers[3].text))])]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [_c("div", [_vm._v(_vm._s(props.headers[4].text))])]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [_c("div", [_vm._v(_vm._s(props.headers[5].text))])]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c("div", [_vm._v(_vm._s(props.headers[6].text))]),
                            _c("div", [_c("span", [_vm._v("afiliación")])])
                          ]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c("div", [_vm._v(_vm._s(props.headers[7].text))]),
                            _c("div", [_c("span", [_vm._v("por equipo")])])
                          ]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c("div", [_vm._v(_vm._s(props.headers[8].text))]),
                            _c("div", [
                              _c("span", [_vm._v("costo por equipo")])
                            ])
                          ]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [_c("div", [_vm._v(_vm._s(props.headers[9].text))])]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c("div", [_vm._v(_vm._s(props.headers[15].text))]),
                            _c("div", [_c("span", [_vm._v("Dólares")])])
                          ]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c("div", [_vm._v(_vm._s(props.headers[10].text))]),
                            _c("div", [_c("span", [_vm._v("mantenimiento")])])
                          ]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c("div", [_vm._v(_vm._s(props.headers[11].text))]),
                            _c("div")
                          ]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c("div", [_vm._v(_vm._s(props.headers[12].text))]),
                            _c("div", [
                              _c("span", [_vm._v("uso de plataforma CE")])
                            ])
                          ]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [_c("div", [_vm._v(_vm._s(props.headers[13].text))])]
                        ),
                        _c(
                          "th",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c("div", [_vm._v(_vm._s(props.headers[14].text))]),
                            _c("div", [_c("span", [_vm._v("renovación")])])
                          ]
                        )
                      ])
                    ]
                  }
                },
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "text-xs-center slide__item-row" },
                          [
                            _c(
                              "div",
                              { staticClass: "slide__switch" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticStyle: {
                                      "background-color":
                                        "transparent !important"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.toDetailTariff(
                                          props.item.idProductTariff,
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("icon-ic-pag-right")])],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.platform === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.platform))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.channel === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.channel))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.subproduct === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.subproduct))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.currency === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.currency))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.affiliation === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.affiliation))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.affiliationComment === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.affiliationComment))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.equipmentCost === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.equipmentCost))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.equipmentCostComment === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.equipmentCostComment))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.maintenance === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.maintenance))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.maintenanceDollar === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.maintenanceDollar))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.maintenanceComment === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.maintenanceComment))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.platformUsageCE === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.platformUsageCE))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.platformUsageCEComment === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.platformUsageCEComment))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.renewal === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.renewal))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center slide__item-row",
                            style:
                              props.item.renewalComment === "No aplica"
                                ? { "background-color": "#CFD8DC" }
                                : { "background-color": "white" }
                          },
                          [_vm._v(_vm._s(props.item.renewalComment))]
                        )
                      ])
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "template",
                { slot: "no-results" },
                [
                  _c(
                    "v-alert",
                    { attrs: { value: true, color: "error", icon: "warning" } },
                    [
                      _c("p", { staticClass: "text-xs-center" }, [
                        _vm._v(
                          'Su búsqueda "' +
                            _vm._s(_vm.search) +
                            '" no encontro resultados.'
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            2
          ),
          _c("newTariffModal", { ref: "newTariffModal" }),
          _c("loader", { ref: "loaderModal", attrs: { text: _vm.loaderText } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd2201aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd2201aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tariff/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-fd2201aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tariff/index.vue
// module chunks = 13